import { routes } from '@/app/routing/router'
import { NewAuthPageView } from './view'

const currentRoute = routes.newAuth

const newAuthRoute = {
  route: currentRoute,
  view: NewAuthPageView,
}

export { currentRoute, newAuthRoute }
